import {
    IOhmOperation,
    OhmNode
} from '@mintdata-wsp/common/controllers/spreadsheet/formula/engine/OhmEngine';

export abstract class BaseFormulaOps<ContextType = any> implements IOhmOperation
{
    protected _context:ContextType = null;

    public constructor(public readonly operationName:string)
    {
    }

    protected __contents(...nodes:Array<OhmNode>):string
    {
        let sb = '';

        for( let node of nodes )
            sb += node.source.contents;

        return sb;
    }

    public setContext(context:ContextType = null):void
    {
        this._context = context;
    }
}
